function decodeBase64Url(value) {
  const normalized = String(value || "").replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
  return atob(padded);
}

export function decodeJwtClaims(token) {
  try {
    const [, payload] = String(token || "").split(".");
    if (!payload) {
      return null;
    }
    return JSON.parse(decodeBase64Url(payload));
  } catch {
    return null;
  }
}

export function getStoredArgusUser() {
  try {
    const rawUser = localStorage.getItem("user");
    return rawUser ? JSON.parse(rawUser) : null;
  } catch {
    return null;
  }
}

function normalizeList(value) {
  return Array.isArray(value) ? value : [];
}

function normalizeRoleValue(value) {
  return String(value || "").trim().toLowerCase();
}

export function getResolvedOlympAccess() {
  // Demo role override — set by the role switcher in MainLayout
  const demoRole = localStorage.getItem('olymp_demo_role');
  if (demoRole && ['admin', 'data_steward', 'user'].includes(demoRole)) {
    return {
      claims: null,
      user: null,
      permissions: [],
      roles: [demoRole],
      role: demoRole,
      isAuthenticated: Boolean(localStorage.getItem('authToken') || localStorage.getItem('user')),
    };
  }

  const token = localStorage.getItem("authToken");
  const claims = decodeJwtClaims(token);
  const user = getStoredArgusUser();
  const roles = normalizeList(claims?.olymp_roles || user?.olymp_roles)
    .map(normalizeRoleValue)
    .filter(Boolean);
  const permissions = normalizeList(claims?.olymp_permissions || user?.olymp_permissions)
    .map(value => String(value || "").trim().toLowerCase())
    .filter(Boolean);

  if (claims?.is_superuser || claims?.is_staff || user?.is_superuser || user?.is_staff) {
    roles.push("admin");
  }

  const roleInOrganization = normalizeRoleValue(
    claims?.role_in_organization || user?.role_in_organization,
  );
  if (roleInOrganization === "admin") {
    roles.push("admin");
  }

  const position = normalizeRoleValue(claims?.position || user?.position);
  if (position.includes("steward")) {
    roles.push("data_steward");
  }
  if (position.includes("admin")) {
    roles.push("admin");
  }

  const uniqueRoles = [...new Set(roles)];
  const inferredRole = uniqueRoles.includes("admin")
    ? "admin"
    : uniqueRoles.includes("data_steward")
      ? "data_steward"
      : (uniqueRoles[0] || "");

  return {
    claims,
    user,
    permissions,
    roles: uniqueRoles,
    role: inferredRole || "user",
    isAuthenticated: Boolean(token || user),
  };
}
